import React, { Component } from 'react';
import { Thumbnail } from 'react-bootstrap';
import ImageModal from './modals/ImageModal';
import VideoModal from './modals/VideoModal';
import SlideModal from './modals/SlideModal';
import PlaylistModal from './modals/PlaylistModal';
import Shedule from './Shedule';
import moment from 'moment';
import Select from './form/Select';
import { Row, Column as Col } from 'hedron';
import { Button, Intent, NonIdealState, Tabs, Tab, TabList, TabPanel } from '@blueprintjs/core';

moment.locale('de');

Object.values = function(object) {
  var values = [];
  for(var property in object) {
    if (object.hasOwnProperty(property)) {
      values.push(object[property]);
    }
  }
  return values;
}

class Customer extends Component {

  constructor(props) {
    super(props);

    this.customerID = props.params.customerID;
    this.storage = props.route.storage;
    this.database = props.route.database;

    this.state = {
      customer: {},
      playlists: {},
      images: {},
      dbCustomerRef: this.database.ref(`customers/${this.customerID}`),
      dbPlaylistsRef: this.database.ref('playlists').orderByChild('customer').equalTo(this.customerID),
      dbSlidesRef: this.database.ref('slides').orderByChild('customer').equalTo(this.customerID),
      dbImagesRef: this.database.ref('images').orderByChild('customer').equalTo(this.customerID),
      dbVideosRef: this.database.ref('videos').orderByChild('customer').equalTo(this.customerID),
      storageRef: this.storage.ref(`customers/${this.customerID}`),
      showImageModal: false,
      showVideoModal: false,
      showNewSlideModal: false,
      showNewPlaylistModal: false,
    }

    this.receiveCustomerListener = this.receiveCustomerListener.bind(this);
    this.receivePlaylistsListener = this.receivePlaylistsListener.bind(this);
    this.receiveSlidesListener = this.receiveSlidesListener.bind(this);
    this.receiveImagesListener = this.receiveImagesListener.bind(this);
    this.receiveVideosListener = this.receiveVideosListener.bind(this);
    this.deleteImage = this.deleteFile.bind(this, 'images');
    this.deleteVideo = this.deleteFile.bind(this, 'videos');
    this.removeSlide = this.removeSlide.bind(this);
    this.removePlaylist = this.removePlaylist.bind(this);
    this.publish = this.publish.bind(this);
    this.getImageOptions = this.getImageOptions.bind(this);
  }

  componentWillMount() {
    this.state.dbCustomerRef.on('value', this.receiveCustomerListener);
    this.state.dbPlaylistsRef.on('value', this.receivePlaylistsListener);
    this.state.dbSlidesRef.on('value', this.receiveSlidesListener);
    this.state.dbImagesRef.on('value', this.receiveImagesListener);
    this.state.dbVideosRef.on('value', this.receiveVideosListener);
  }

  componentWillUnmount() {
    this.state.dbCustomerRef.off('value', this.receiveCustomerListener);
    this.state.dbPlaylistsRef.off('value', this.receivePlaylistsListener);
    this.state.dbSlidesRef.off('value', this.receiveSlidesListener);
    this.state.dbImagesRef.off('value', this.receiveImagesListener);
    this.state.dbVideosRef.off('value', this.receiveVideosListener);
  }

  deleteFile(folder, fileID) {
    const slidesWithFile = Object.values(this.state.slides).filter((slide) => {
      if (typeof slide.templateData !== 'object') return false;
      const fileIsOnSlide = Boolean(Object.values(slide.templateData).find((v) => v === fileID));
      return fileIsOnSlide;
    }).map(slide => slide.name);
    if (slidesWithFile.length > 0) {
      return alert(`Datei konnte nicht gelöscht werden, da sie sich noch auf folgenden Slides befindet: ${slidesWithFile.join(', ')}`);
    }

    this.state.storageRef.child(folder).child(fileID).delete()
    .then(() => {
      this.database.ref(`${folder}/${fileID}`).remove();
    })
    .catch((err) => {
      if (err.code === 'storage/object-not-found') {
        this.database.ref(`${folder}/${fileID}`).remove();
      } else {
        console.log(err);
        console.log(err.code);
      }
    });
  }

  publish() {
    this.state.dbCustomerRef.child('publishedAt').set(Date.now());
  }

  receiveCustomerListener(snap) {
    this.setState({ customer: snap.val() });
  }

  receivePlaylistsListener(snap) {
    this.setState({ playlists: snap.val() });
  }

  receiveSlidesListener(snap) {
    this.setState({ slides: snap.val() });
  }

  receiveImagesListener(snap) {
    const images = snap.val() || {};
    return this.setState({ images });
  }

  receiveVideosListener(snap) {
    const videos = snap.val() || {};
    this.setState({ videos });
  }

  removePlaylist(playlistID) {
    const scheduleEntriesWithPlaylist = Object.values(this.state.customer.shedule).filter((entry) => {
      console.log(entry.playlist)
      return entry.playlist && entry.playlist === playlistID;
    });
    if (scheduleEntriesWithPlaylist.length > 0) {
      return alert('Playlist konnte nicht gelöscht werden, da sie noch im Zeitplan verwendet wird.');
    }
    this.database.ref(`playlists/${playlistID}`).remove()
  }

  removeSlide(slideID) {
    const playlistsWithSlide = Object.values(this.state.playlists).filter((playlist) => {
      if (typeof playlist.slides !== 'object') return false;
      const fileIsOnSlide = Boolean(Object.values(playlist.slides).find((v) => v === slideID));
      return fileIsOnSlide;
    }).map(playlist => playlist.name);
    if (playlistsWithSlide.length > 0) {
      return alert(`Slide konnte nicht gelöscht werden, da sie sich noch auf folgenden Playlists befindet: ${playlistsWithSlide.join(', ')}`);
    }
    this.database.ref(`slides/${slideID}`).remove()
  }

  getImageOptions() {
    const images = [];
    for (let key in this.state.images) {
      if (!this.state.images.hasOwnProperty(key)) continue;
      const image = this.state.images[key];
      images.push(
        { value: key, label: image.name }
      );
    }
    return images;
  }

  renderPlaylistRows() {
    const rows = [];
    for (let key in this.state.playlists) {
      if (!this.state.playlists.hasOwnProperty(key)) continue;

      const playlistData = this.state.playlists[key];
      rows.push(
        <tr key={`customerListRow_${key}`}>
          <td>{key}</td>
          <td>{playlistData.name}</td>
          <td>{playlistData.color}</td>
          <td>
            <Button iconName="edit" onClick={() => { this.setState({ showPlaylistModalForID: key }) }} />&nbsp;
            <Button iconName="delete" intent={Intent.DANGER} onClick={() => this.removePlaylist(key)} />
          </td>
        </tr>
      );
    }
    if (!rows.length) {
      return (
        <NonIdealState
          visual="numbered-list"
          title="Keine Playlist vorhanden"
          description="Solbald Playlists Hochgeladen sind erscheint hier eine Liste."
        />
      );
    }
    return rows;
  }

  renderSlideRows() {
    const rows = [];
    for (let key in this.state.slides) {
      if (!this.state.slides.hasOwnProperty(key)) continue;

      const slideData = this.state.slides[key];
      rows.push(
        <tr key={`customerListRow_${key}`}>
          <td>{key}</td>
          <td>{slideData.name}</td>
          <td>{slideData.description}</td>
          <td>{slideData.template}</td>
          <td>
            <Button iconName="edit" onClick={() => { this.setState({ showSlideModalForID: key }) }} />&nbsp;
            <Button iconName="delete" intent={Intent.DANGER} onClick={() => this.removeSlide(key)} />
          </td>
        </tr>
      );
    }
    if (!rows.length) {
      return (
        <NonIdealState
          visual="layers"
          title="Keine Slides vorhanden"
          description="Solbald Slides Hochgeladen sind erscheint hier eine Liste."
        />
      );
    }
    return rows;
  }

  renderImageThumbnails() {
    const rows = [];
    for (let key in this.state.images) {
      if (!this.state.images.hasOwnProperty(key)) continue;

      const imageData = this.state.images[key];
      rows.push(
        <Col sm={3} key={`imageCol_${key}`}>
          <div className="pt-card">
            <img width="100%" src={imageData.url} alt="242x200" />
            <span className="pt-ui-text-large">{imageData.name}</span>
            <p>{imageData.description}</p>
            <p>ID: {key}</p>
            <p>
              <button className="pt-button pt-intent-danger" onClick={() => this.deleteImage(key)}>
                Löschen
              </button>
            </p>
          </div>
        </Col>
      );
    }
    if (!rows.length) {
      return (
        <NonIdealState
          visual="media"
          title="Keine Bilder vorhanden"
          description="Solbald Bilder Hochgeladen sind erscheint hier eine Liste."
        />
      );
    }
    return rows;
  }

  renderVideoPanels() {
    const rows = [];

    for (let key in this.state.videos) {
      if (!this.state.videos.hasOwnProperty(key)) continue;

      const videoData = this.state.videos[key];
      rows.push(
        <Col sm={3} key={`videoCol_${key}`}>
          <div className="pt-card" src={videoData.url} alt="242x200">
            <span className="pt-ui-text-large">{videoData.name}</span>
            <video width="100%" height="150" controls preload="none">
              <source src={videoData.url} type="video/mp4" />
            </video>
            <p>{videoData.description}</p>
            <p>ID: {key}</p>
            <p>
              <button className="pt-button pt-intent-danger" onClick={() => this.deleteVideo(key)}>
                Löschen
              </button>
            </p>
          </div>
        </Col>
      );
    }
    if (!rows.length) {
      return (
        <NonIdealState
          visual="video"
          title="Keine Videos vorhanden"
          description="Solbald Videos Hochgeladen sind erscheint hier eine Liste."
        />
      );
    }
    return rows;
  }

  render() {
    return (
      <div className="customer">
        <Row>
          <Col sm={10}>
            <h3>{this.state.customer.name}</h3>
            <div className="customerDetails">
              ID: {this.props.params.customerID}
            </div>
          </Col>
          <Col sm={2}>
            <Button
              text="Publish"
              intent={Intent.PRIMARY}
              iconName="automatic-updates"
              onClick={this.publish} />
            <div className="customerDetails">
              Zuletzt aktualisiert {moment(this.state.customer.publishedAt).fromNow()}
            </div>
          </Col>
        </Row>
        <Tabs>
          <TabList>
            <Tab>Schedule</Tab>
            <Tab>Playlists</Tab>
            <Tab>Slides</Tab>
            <Tab>Bilder</Tab>
            <Tab>Videos</Tab>
            <Tab>Placeholder</Tab>
          </TabList>
          <TabPanel>
            <Shedule
              playlists={this.state.playlists}
              database={this.props.route.database}
              customerID={this.props.params.customerID}
              customer={this.state.customer}
              shedule={this.state.customer.shedule || {}}
            />
          </TabPanel>
          <TabPanel>
            <h3>Playlists</h3>
            <Button
              text="Neue Playlist anlegen"
              iconName="numbered-list"
              onClick={() => this.setState({ showPlaylistModalForID: 'new' })} />
            <table className="pt-table pt-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Farbe</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {this.renderPlaylistRows()}
              </tbody>
            </table>
          </TabPanel>
          <TabPanel>
            <h3>Slides</h3>
            <Button
              iconName="layers"
              text="Neue Slide anlegen"
              onClick={() => this.setState({ showSlideModalForID: 'new' })} />
            <table className="pt-table pt-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Beschreibung</th>
                  <th>Template</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {this.renderSlideRows()}
              </tbody>
            </table>
          </TabPanel>
          <TabPanel>
            <h3>Bilder</h3>
            <Row>
              <Col sm={12}>
                <Button
                  iconName="media"
                  text="Neues Bild hochladen"
                  onClick={() => this.setState({ showImageModal: true })} />
              </Col>
              {this.renderImageThumbnails()}
            </Row>
          </TabPanel>
          <TabPanel>
            <h3>Videos</h3>
            <Row>
              <Col sm={12}>
                <Button
                  iconName="video"
                  text="Neues Video hochladen"
                  onClick={() => this.setState({ showVideoModal: true })} />
              </Col>
              {this.renderVideoPanels()}
            </Row>
          </TabPanel>
          <TabPanel>
            <Row>
              <Col sm={12}>
                <h3>Keine Playlist Placeholder</h3>
                <div class="pt-select">
                  <Select
                    label='Fallback'
                    controlId='Fallback'
                    validationState={null}
                    sm={6}
                    placeholder="Bild wählen"
                    options={this.getImageOptions()}
                    value={this.state.customer.backgroundImage}
                    onChange={(e) => {
                      this.state.dbCustomerRef.child('backgroundImage').set(e.target.value);
                    }}
                  />
                </div>
                <img role="presentation" height={200} src={(this.state.customer.backgroundImage) ? this.state.images[this.state.customer.backgroundImage].url : ''} />
              </Col>
            </Row>
          </TabPanel>
        </Tabs>
        <ImageModal
          show={this.state.showImageModal}
          hide={() => this.setState({ showImageModal: false })}
          customerStorageRef={this.state.storageRef}
          database={this.props.route.database}
          customerID={this.props.params.customerID}
        />
        <VideoModal
          show={this.state.showVideoModal}
          hide={() => this.setState({ showVideoModal: false })}
          customerStorageRef={this.state.storageRef}
          database={this.props.route.database}
          customerID={this.props.params.customerID}
        />
        <SlideModal
          show={Boolean(this.state.showSlideModalForID)}
          hide={() => this.setState({ showSlideModalForID: false })}
          database={this.props.route.database}
          slideID={this.state.showSlideModalForID}
          customerID={this.props.params.customerID}
          images={this.state.images}
          videos={this.state.videos}
        />
        <PlaylistModal
          show={Boolean(this.state.showPlaylistModalForID)}
          hide={() => this.setState({ showPlaylistModalForID: false })}
          database={this.props.route.database}
          customerID={this.props.params.customerID}
          playlistID={this.state.showPlaylistModalForID}
          slides={this.state.slides}
        />
      </div>
    );
  }
}

export default Customer;



/** WEBPACK FOOTER **
 ** ./src/Customer.js
 **/